import { Modal } from '@mui/material';
import Button from './Button';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import * as S from './ConfirmationModal.styled';

const DeleteChatMessageConfirmationModal = ({
    open,
    mobile,
    messageId,
    toggleDeleteChatMessageModal,
    handleDeleteChatMessage,
}: {
    open: boolean;
    mobile: boolean;
    messageId: number | null;
    toggleDeleteChatMessageModal: () => void;
    handleDeleteChatMessage: (id: number) => void;
}) => {
    const { language_setting: language } = useSelector((state: RootState) => state.user.entity);
    const { t } = useTranslation();
    return (
        <>
            {messageId && (
                <Modal
                    sx={{ zIndex: '10000' }}
                    open={open}
                    onClose={() => toggleDeleteChatMessageModal()}
                >
                    <S.ModalWrapper mobile={mobile}>
                        <S.Modal>
                            <S.ModalButtonWrapper>
                                <S.IconBtn onClick={() => toggleDeleteChatMessageModal()}>
                                    <S.CrossSimpleIcon />
                                </S.IconBtn>
                            </S.ModalButtonWrapper>
                            <S.Container>
                                <S.Text> {t('areYouSureDeleteMessage', { lng: language })}</S.Text>

                                <S.ButtonContainer>
                                    <Button
                                        background="green"
                                        style={{ minWidth: '5rem' }}
                                        onClick={() => {
                                            handleDeleteChatMessage(messageId);
                                            toggleDeleteChatMessageModal();
                                        }}
                                    >
                                        {t('confirm', { lng: language })}
                                    </Button>
                                    <Button
                                        background="purple"
                                        style={{ minWidth: '5rem' }}
                                        onClick={() => toggleDeleteChatMessageModal()}
                                    >
                                        {t('cancel', { lng: language })}
                                    </Button>
                                </S.ButtonContainer>
                            </S.Container>
                        </S.Modal>
                    </S.ModalWrapper>
                </Modal>
            )}
        </>
    );
};
export default DeleteChatMessageConfirmationModal;
